// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"460":"8a45ff57","787":"dfd8624f"}[chunkId] + ".chunk.js";
};